<template>
<div class="settings-menu">
    <div class="category">
        <div class="category-title">Account</div>
        <!-- BEGIN Details -->
        <router-link :to="{ name: 'detailsSettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('details') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon icon="address-card"/>
                    </div>
                    <span>Details</span>
                </div>
            </a>
        </router-link>
        <!-- END Details -->

        <!-- BEGIN Security -->
        <router-link :to="{ name: 'securitySettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('security') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon icon="lock"/>
                    </div>
                    <span>Password</span>
                </div>
            </a>
        </router-link>
        <router-link :to="{ name: 'twoFactorAuthSettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('2fa') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon :icon="['fas', 'shield-alt']"/>
                    </div>
                    <span>Two Factor Auth</span>
                </div>
            </a>
        </router-link>
        <!-- END Security -->

        <!-- BEGIN Notifications -->
        <!-- <a href="/settings/notifications" class="item" :class="{ 'item-selected': isActiveItem('update-notifications') }">
            <div class="item-container">
                <div class="icon-container">
                    <font-awesome-icon icon="bell"/>
                </div>
                <span>Notifications</span>
            </div>
        </a> -->
        <!-- END Notifications -->
    </div>

    <!-- <div class="category"> -->
        <!-- <div class="category-title">Notification channels</div> -->
        <!-- BEGIN SMS channel -->
        <!-- <a href="/settings/channel/sms" class="item" :class="{ 'item-selected': isActiveItem('sms-channel') }">
            <div class="item-container">
                <div class="icon-container">
                    <font-awesome-icon icon="mobile-alt"/>
                </div>
                <span>SMS</span>
            </div>
        </a> -->
        <!-- END Sms channel -->

        <!-- BEGIN Slack -->
        <!-- <a href="/settings/channel/slack" class="item" :class="{ 'item-selected': isActiveItem('slack-channel') }">
            <div class="item-container">
                <div class="icon-container">
                    <font-awesome-icon :icon="['fab', 'slack']"/>
                </div>
                <span>Slack</span>
            </div>
        </a> -->
        <!-- END Slack -->
    <!-- </div> -->

    <div class="category">
        <div class="category-title">Database & File Backups</div>

        <router-link :to="{ name: 'serversSettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('servers') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon icon="server"/>
                    </div>
                    <span>Servers</span>
                </div>
            </a>
        </router-link>

        <router-link :to="{ name: 'storagesSettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('storages') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon icon="hdd"/>
                    </div>
                    <span>Storages</span>
                </div>
            </a>
        </router-link>
        
        <router-link :to="{ name: 'encryptionKeysSettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('encryptionKeys') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon icon="key"/>
                    </div>
                    <span>Encryption keys</span>
                </div>
            </a>
        </router-link>
    </div>

    <div class="category">
        <div class="category-title">Billing</div>

        <router-link :to="{ name: 'subscriptionSettings' }">
            <a class="item" :class="{ 'item-selected': isActiveItem('subscription') }">
                <div class="item-container">
                    <div class="icon-container">
                        <font-awesome-icon icon="credit-card"/>
                    </div>
                    <span>Subscription</span>
                </div>
            </a>
        </router-link>

        <!-- <a class="item" :class="{ 'item-selected': isActiveItem('credit-card') }">
            <div class="item-container">
                <div class="icon-container">
                    <font-awesome-icon icon="credit-card"/>
                </div>
                <span>Credit card</span>
            </div>
        </a> -->

        <!-- BEGIN Purchase history -->
        <!-- <a class="item" :class="{ 'item-selected': isActiveItem('payments') }">
            <div class="item-container">
                <div class="icon-container">
                    <font-awesome-icon icon="history"/>
                </div>
                <span>Payments</span>
            </div>
        </a> -->
        <!-- END Purchase history -->

    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            teamsLoaded: false,
            teams: [],
        }
    },

    props: ['activeItem'],

    mounted() {
        this.listenForEvents();
    },

    methods: {
        isActiveItem(item) {
            return this.activeItem === item;
        },

        teamItemName(team) {
            return 'team-' + team.id;
        },

        getTeamUrl(team) {
            return '/settings/team/' + team.id;
        },

        listenForEvents() {
            Event.$on('reloadSettingsMenu', (successCallback) => {
                this.getTeams(successCallback);
            });
        },
    },

    computed: {
        dataLoaded() {
            return this.teamsLoaded;
        },
    },

    watch: {
        activeItem(item) {
            Event.$emit('activeItemChanged', item);
        },
    }
}
</script>
